import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export default class Footer extends Component {
    render() {
        return (
            /** footer */
            <footer className="page-footer">
                <div className="block-footer-bottom">
                    <div data-content-type="row">
                        <div data-enable-parallax={0} data-parallax-speed="0.5" data-background-images="{}" data-element="inner" data-pb-style="63F9139F27960">
                            <div data-content-type="html" data-appearance="default" data-element="main" data-pb-style="63F9139F27975" data-decoded="true">
                                <div className="container">
                                    <div className="main">
                                        <div className="footer">
                                            <div className="row">
                                            <div className="col-lg-3 col-md-3 col-sm-2 col-xs-12">
                                                <div className="collapsible mobile-collapsible">
                                                <a href="/">
                                                    <img src="./image/ZOLL-by-KTI.png" alt="logo" title="ZOLL"/>
                                                </a>
                                                <span className="toggle-tab mobile" style={{display: 'none'}}>
                                                    <span className="hidden">hidden</span>
                                                </span>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-2 col-sm-2 col-xs-12">
                                                <div className="links collapsible mobile-collapsible">
                                                <div className="block-title">
                                                    <strong>
                                                    <span>Company</span>
                                                    </strong>
                                                </div>
                                                <ul>
                                                    <li className="last privacy">
                                                        <a href="https://www.kurniateknologi.com/" title="About ZOLL" target="_blank" rel="noreferrer">Kunia Teknologi Indonesia</a>
                                                    </li>
                                                    <li className="last privacy">
                                                    <Link to='/contact-us'>Contact Us</Link>
                                                    </li>
                                                </ul>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-2 col-sm-2 col-xs-12">
                                                <div className="links quick-links-footer collapsible mobile-collapsible">
                                                <div className="block-title">
                                                    <strong>
                                                    <span>Quick Links</span>
                                                    </strong>
                                                </div>
                                                <ul>
                                                    <li>
                                                    <Link to='/contact-us'>Contact Us</Link>
                                                    </li>
                                                    <li>
                                                    <a href="https://www.kurniateknologi.com/faq" target="_blank" rel="noreferrer">FAQ</a>
                                                    </li>
                                                    <li>
                                                    <a href="https://www.kurniateknologi.com/blog" target="_blank" rel="noreferrer">Blog</a>
                                                    </li>
                                                </ul>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-2 col-xs-12">
                                                <div className="collapsible mobile-collapsible">
                                                <div className="toggle-content block-content block-content-statick">
                                                    <div className="social-block">
                                                    <div data-content-type="row" data-appearance="contained" data-element="main">
                                                        <div data-enable-parallax={0} data-parallax-speed="0.5" data-background-images="{}" data-element="inner" data-pb-style="63F9139F257DC">
                                                        <div data-content-type="html" data-appearance="default" data-element="main" data-pb-style="63F9139F257F1" data-decoded="true">
                                                            <div className="footer-social links">
                                                            <div className="block-title">
                                                                <strong>
                                                                <span>Follow Us</span>
                                                                </strong>
                                                            </div>
                                                            <div className="icon-container">
                                                                <ul className="social-icons row-1">
                                                                <li>
                                                                    <a target="_blank" rel="noreferrer" title="Check us out on Instagram" href="https://www.instagram.com/kurniateknologi?igsh=MWczbXFreTY0aXU4OA==">
                                                                    <i className="icon-instagram">
                                                                        <span>instagram</span>
                                                                    </i>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a target="_blank" rel="noreferrer" title="Check us out on Linkedin" href="https://www.linkedin.com/company/pt-kurnia-teknologi-indonesia-kti/">
                                                                    <i className="icon-linkedin">
                                                                        <span>linkedin</span>
                                                                    </i>
                                                                    </a>
                                                                </li>
                                                                </ul>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="footer-links-company">
                    <div className="container">
                        <div className="main">
                            <div className="footer-copyright">
                            <div className="main1">
                                <small className="copyright">
                                <span>© ZOLL by PT Kurnia Teknologi Indonesia. All Rights Reserved.</span>
                                </small>
                            </div>
                            <a href="#backtotop" id="backtotop">
                                <span className="fa fa-angle-up" />
                                <span className="back-to-top">Back to Top</span>
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        )
    }
}
